import { hasWindow } from './browser.utils';

interface EmbeddedLinkProps {
  href?: string;
  type?:
    | 'internal'
    | 'external'
    | 'closeModal'
    | 'openModal'
    | 'analytics'
    | 'analytics-add-coupon-code'
    | 'analytics-saudi-rewards-linked'
    | 'openEmail'
    | 'checkoutSuccess'
    | 'orderCancelled';
  value?: object;
}

export const postMessageRN = ({
  href,
  type = 'external',
  value,
}: EmbeddedLinkProps) => {
  // ios uses window.webkit.messageHandlers.ReactNativeWebView.postMessage
  if (hasWindow() && !!window?.webkit?.messageHandlers?.ReactNativeWebView) {
    window?.webkit?.messageHandlers?.ReactNativeWebView?.postMessage(
      JSON.stringify({ href, type, value }),
    );
    // Android uses window.ReactNativeWebView.postMessage
  } else if (hasWindow() && !!window?.ReactNativeWebView) {
    window?.ReactNativeWebView?.postMessage(
      JSON.stringify({ href, type, value }),
    );
  }
};
